  export default "https://staging.project-progress.net/projects/equantiis/wp-json/industry-expertise/lp";

// export default "https://beta.equantiis.com/wp-json/industry-expertise/lp";
